module.exports = __webpack_public_path__ + "img/tws13.4f2be6ae.png";